export function getImageUrl(imageBlob) {
    if (imageBlob instanceof Blob) {
        const url =URL.createObjectURL(imageBlob);
      return url;
    } else {
      return imageBlob;
    }
  }

  